import { useState } from 'react';

import { IconCheckDefault, IconCopyOutline } from '@iwoca/icons';

const COPIED_RESET_MS = 2000;

export const CopyButton = ({
    value,
    ariaLabel
}: {
    value: string;
    ariaLabel: string;
}) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        const result = navigator.clipboard?.writeText(value);
        if (result) {
            result
                .then(() => {
                    setCopied(true);
                    setTimeout(() => setCopied(false), COPIED_RESET_MS);
                })
                .catch(() => {});
        }
    };

    return (
        <button
            onClick={handleCopy}
            className="inline-flex min-h-[44px] min-w-[44px] cursor-pointer items-center justify-center border-0 bg-transparent p-xs"
            aria-label={ariaLabel}
        >
            {copied ? (
                <span data-testid="icon-copied">
                    <IconCheckDefault className="size-l fill-success-mid" />
                </span>
            ) : (
                <span data-testid="icon-copy">
                    <IconCopyOutline className="size-l fill-primary-10" />
                </span>
            )}
        </button>
    );
};
